import React from "react";

export default function StatusPipeline({ stages, currentStage }) {
  const currentIndex = stages.indexOf(currentStage);

  return (
    <div className="flex items-center text-xs font-bold select-none justify-end">
      {stages.map((stage, index) => {
        const isActive = index === currentIndex;
        const isPast = index < currentIndex;
        
        // 🟢 Odoo Styling Logic
        // Active: Dark Purple bg, White text
        // Past: Light Purple bg, Purple text (Interactive feel)
        // Future: Gray bg, Gray text
        
        let textColor = "text-gray-500 dark:text-slate-400";
        let bgColor = "bg-gray-100 dark:bg-[#161b22]";
        let zIndex = stages.length - index; // Stack left-on-top-of-right

        if (isActive) {
            textColor = "text-white";
            bgColor = "bg-purple-700 dark:bg-purple-600";
        } else if (isPast) {
            textColor = "text-purple-700 dark:text-purple-300"; 
            bgColor = "bg-purple-50 dark:bg-purple-950/60"; 
            // Optional: Add hover effect for past stages if you implement click-to-move later
        } else {
            textColor = "text-gray-500 dark:text-slate-400";
            bgColor = "bg-gray-200 dark:bg-[#21262d]"; 
        }

        return (
          <div 
            key={stage}
            className={`
                relative h-[30px] flex items-center justify-center pl-6 pr-3 
                transition-all duration-200
                ${textColor} ${bgColor} 
                first:pl-4 
            `}
            style={{ 
                // 🟢 The Sharp Arrow Shape
                clipPath: index === 0 
                    ? "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%)" // Flat Left (First Item)
                    : "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%, 10px 50%)", // Arrow Left (Others)
                
                marginLeft: index === 0 ? 0 : "-4px", // Negative margin to overlap arrows
                zIndex: zIndex, // Ensures the arrow tip sits "on top" of the next item
                minWidth: "80px" 
            }}
          >
            <span className="truncate max-w-[120px] uppercase tracking-tight text-[10px] md:text-[11px]">
                {stage}
            </span>
          </div>
        );
      })}
    </div>
  );
}